import React, { useState, useEffect, useContext, useCallback } from 'react';
import {
  Text,
  Box,
  Image,
  Tabs,
  TabList,
  TabPanels,
  TabPanel,
  Button,
  Flex,
  Spacer,
  VStack,
  HStack,
  Icon,
  Tab,
  Switch,
  IconButton,
} from '@chakra-ui/react';
import { useNavigate, useLocation } from 'react-router-dom';
import { AccountContext } from '../AccountContext';
import Loading from '../LoadingWithHeader';
import NoUserHeader from '../AreaLivre/NoUserHeader';
import ChildHeader from '../Dashboard/Main/ChildHeader';
import AvisoPendencias from '../../images/AvisoPendencias.svg';
import FamiliaIcon from '../../images/dashboard/familia.svg';
import DrawerIndicacao from './DrawerIndicacao';
import { loadPlans } from 'api/plans';
import { api } from 'api/api';
import useModelPagamentoTelemed from '../Dashboard/Telemedicina/useModelPagamentoTelemed';
import { FaCheck, FaStar, FaUser } from 'react-icons/fa6';
import { MdFamilyRestroom } from 'react-icons/md';
import { CloseIcon } from '@chakra-ui/icons';

const ENDPOINT =
  process.env.REACT_APP_ENVIRONMENT === 'production'
    ? process.env.REACT_APP_BASE_URL_API_SERVER_PROD
    : process.env.REACT_APP_BASE_URL_API_SERVER_TEST;

function Plano({ telemedicina, onLoaded }) {
  const [plans, setPlans] = useState([]);
  const [drawerOpen, setDrawerOpen] = useState(true);
  const [maxParcelas, setMaxParcelas] = useState(null);
  const { state } = useLocation();
  telemedicina = state?.telemedicina;
  const { user, setPage, setUser } = useContext(AccountContext);
  const [error, setError] = useState(false);
  const [assinaturaLiberada, setAssinaturaLiberada] = useState(false);
  const [loading, setLoading] = useState(true);
  const [loadingAssinatura, setLoadingAssinatura] = useState(true);
  const [menorValor, setMenorValor] = useState(null);
  const [isAnual, setIsAnual] = useState(true);
  let clientId = state?.client_id ? state?.client_id : user.id_cliente_deovita;

  const navigate = useNavigate();
  // Hook deve ser chamado no topo
  const { fetchVincularVoucher } = useModelPagamentoTelemed();

  let planoRestrito = null;
  let formaRestrita = null;
  let descontoPlano = null;
  let valorFinalPlano = null;
  let valorBasePlano = null;
  let parcelasRestritas = null;
  let descricaoVoucher = null;
  let planosExibir = plans;
  let voucherInfo = null;
  if (user && user.voucher && user.voucher.voucher && user.voucher.voucher.voucher_type === 'Assinatura') {
    planoRestrito = user.voucher.voucher.plano_id;
    formaRestrita = user.voucher.voucher.forma_id;
    descontoPlano = user.voucher.voucher.percent;
    valorFinalPlano = user.voucher.voucher.valor_final;
    parcelasRestritas = user.voucher.voucher.parts;
    planosExibir = plans.filter((p) => String(p.id) === String(planoRestrito));
    planosExibir = planosExibir.map((p) => {
      const parcelasFiltradas = p.parcelas.filter(
        (parc) => String(parc.forma_id) === String(formaRestrita) && String(parc.quantidade) === String(parcelasRestritas),
      );
      return {
        ...p,
        parcelas: parcelasFiltradas.length > 0 ? parcelasFiltradas : p.parcelas,
      };
    });
    voucherInfo = {
      desconto: descontoPlano,
      valorFinal: valorFinalPlano,
      formaPagamento: user.voucher.voucher.forma_pagamento,
      planoId: planoRestrito,
      planoNome: user.voucher.voucher.plano,
    };
  }

  useEffect(() => {
    setPage('Planos DeoVita');
  }, [setPage]);

  useEffect(() => {
    (async () => {
      try {
        const data = await loadPlans();

        const valores = data
          .flatMap((plano) => plano.parcelas || [])
          .map((parcela) => Number(parcela.min_valor))
          .filter((valor) => !isNaN(valor));

        const menor = valores.length > 0 ? Math.min(...valores) : null;

        const allParcelas = data.flatMap((plano) => plano.parcelas || []);
        const maxParcelasValue = allParcelas.length > 0 ? Math.max(...allParcelas.map((p) => p.quantidade)) : null;
        setMaxParcelas(maxParcelasValue);

        setMenorValor(menor);
        setPlans(data);
      } catch (error) {
        setError(true);
      } finally {
        setLoading(false);
      }
    })();
  }, []);

  useEffect(() => {}, [user, assinaturaLiberada, loading]);

  const getCancelamento = useCallback(() => {
    setLoadingAssinatura(true);
    api(`${ENDPOINT}/clients/getContratoCancelado`, {
      method: 'POST',
      credentials: 'include',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ cpf: user?.cpf }),
    })
      .catch((err) => {
        console.log(err);
        return;
      })
      .then(async (res) => {
        if (!res || !res.ok || res.status >= 400) {
          console.log(res);
          return;
        }
        return await res.json();
      })
      .then(async (resposta) => {
        setLoadingAssinatura(false);
        if (resposta?.data !== undefined && resposta?.data.length) {
          const dataAtual = new Date();
          const dataCadastro = new Date(resposta.data[0].data_cadastro);

          const dataCadastroSimples = new Date(dataCadastro.getFullYear(), dataCadastro.getMonth(), dataCadastro.getDate());

          const dataCadastroMais90Dias = new Date(dataCadastroSimples);
          dataCadastroMais90Dias.setDate(dataCadastroMais90Dias.getDate() + 90);

          const dataAtualSimples = new Date(dataAtual.getFullYear(), dataAtual.getMonth(), dataAtual.getDate());

          const resultado = dataAtualSimples >= dataCadastroMais90Dias;

          if (!resultado) {
            //O cancelamento do cliente não completou noventa dias
            if (state?.tipo !== 'recontratar_plano') {
              setAssinaturaLiberada(false);
              return;
            }
          }
          setAssinaturaLiberada(true);
        } else {
          setAssinaturaLiberada(true);
        }
      });
  }, [state?.tipo, user?.cpf]);

  useEffect(() => {
    getCancelamento();
  }, [getCancelamento]);

  useEffect(() => {
    return () => {
      if (user && user.voucher && user.voucher.voucher && user.voucher.voucher.voucher_type === 'Assinatura' && !assinaturaLiberada) {
        setUser((prevUser) => ({
          ...prevUser,
          voucher: null,
        }));
      }
    };
  }, [user, assinaturaLiberada, setUser]);

  useEffect(() => {
    if (menorValor != null) {
      onLoaded?.(menorValor);
    }
  }, [menorValor, onLoaded]);

  if (loadingAssinatura || loading) {
    return <Loading />;
  }

  async function handleSubmit(planoArg) {
    const plano = planoArg;
    const parcela = isAnual ? plano.parcelas.find((p) => p.quantidade === 1) : plano.parcelas.find((p) => p.quantidade === 12);
    if (!parcela) return;
    let valorPlano = parcela.min_valor;
    let valorPlanoFormatado = Number(parcela.min_valor).toLocaleString('pt-br', {
      style: 'currency',
      currency: 'BRL',
    });
    let valorEconomizado = 0;
    if (
      user &&
      user.voucher &&
      user.voucher.voucher &&
      user.voucher.voucher.voucher_type === 'Assinatura' &&
      String(plano.id) === String(user.voucher.voucher.plano_id)
    ) {
      const descontoPercent = Number(user.voucher.voucher.percent);
      valorPlano = Number(parcela.min_valor) * (1 - descontoPercent / 100);
      valorPlanoFormatado = Number(valorPlano).toLocaleString('pt-br', {
        style: 'currency',
        currency: 'BRL',
      });
      valorEconomizado = Number(parcela.min_valor) - valorPlano;
      await fetchVincularVoucher(user.voucher.voucher.voucher, valorPlano, parcela.min_valor);
    }
    let params = {
      ...state,
      client_id: user.id_cliente_deovita,
      name: user.name,
      cpf: user.cpf,
      id_plano: plano.id,
      nome_plano: plano.nome,
      dependentes_plano: plano.qtd_dependentes,
      parcelsActive: true,
      valor: valorPlano,
      valor_plano: valorPlano,
      valor_plano_formatado: valorPlanoFormatado,
      frequenciaText: `Assinatura Plano ${plano.nome}`,
      plano_anual: isAnual,
      frequencia: parcela.quantidade,
      navig_to: '/alerts/sucesso/telemedicina2/',
      expiration_pix_in_min: 5,
      item: {
        client_id: user.id_cliente_deovita,
        nome: user.name,
        fone: user?.phone1 ? user.phone1 : user?.phone2,
        adicionais: null,
        plano: plano.id,
        phone: user?.phone1 ? user.phone1 : user?.phone2,
      },
      service: 'contract',
      voucher: user.voucher ? user.voucher : null,
      descricao_plano: plano.nome,
      plano: plano,
      parcela: parcela,
      phone: user?.phone1 ? user.phone1 : user?.phone2,
      valorEconomizado: valorEconomizado,
      valor_original: parcela.min_valor,
    };

    let carrinho = [{ id: 0, nome: params.nome_plano, valor: params.valor_plano_formatado, valor_numerico: params.valor_plano }];

    if (!user.loggedIn) {
      navigate('/cadastro', { state: { assinatura: { dados: params, carrinho: carrinho } } });
      return;
    }
    
    if(user.termo){
      navigate('/pagamentos', { state: { ...params, carrinho: carrinho } });
      return
    }

    navigate('/termo-de-adesao', { state: { dados: params, carrinho: carrinho } });
    return;
  }

  function PlanoCard({ planId, titulo, preco, beneficios, color, recomendado, onAssinar }) {
    const isFamilia = planId === 29;
    const mainColor = planId === 29 ? '#EB8B2A' : color || '#2A918A';
    return (
      <Box border={`2px solid ${isFamilia ? '#EB8B2A' : '#B6D5D4'}`} borderRadius="20px" bg={isFamilia ? '#FFF5EC' : '#F7FDFC'} p={5} boxShadow="sm">
        <VStack align="start" spacing={4}>
          {recomendado && (
            <Box w="100%" display="flex" justifyContent="center">
              <HStack
                borderRadius={'0.8em'}
                p={2}
                spacing="3px"
                align={'center'}
                alignItems={'center'}
                bg={isFamilia ? '#EB8B2A' : '#2A918A'}
                color={'white'}
                justifyContent="center"
                w="50%"
              >
                <Icon as={FaStar} />
                <Text fontSize="sm">Recomendado!</Text>
              </HStack>
            </Box>
          )}
          <Text fontWeight="bold" fontSize="1.2em" color={mainColor}>
            {titulo}
          </Text>

          <Text fontSize="4xl" fontWeight="bold" color={mainColor} display="flex" alignItems="center" gap={2}>
            {preco}
            <Text as="span" fontSize="md" color="#6C6C6C">
              {isAnual ? '/anual' : '/mês'}
            </Text>
          </Text>
          <Box bg={'#FFFFFFB2'} p={4} borderRadius="12px" w="100%" border={isFamilia ? '1px solid #EB8B2A' : '1px solid #D8EAE9'}>
            <VStack align="start" spacing={3}>
              {beneficios.map((b, index) => (
                <HStack key={index} align="start">
                  <Icon as={FaCheck} color={mainColor} mt={1} />
                  <Text color="#3A3A3A">{b}</Text>
                </HStack>
              ))}
            </VStack>
          </Box>
          <Button
            onClick={onAssinar}
            w="100%"
            bg={mainColor}
            color="white"
            borderRadius="full"
            size="lg"
            _hover={{ bg: isFamilia ? '#d97a1c' : '#237973' }}
          >
            Quero este plano!
          </Button>
        </VStack>
      </Box>
    );
  }

  return planosExibir.length && !loadingAssinatura ? (
    !assinaturaLiberada ? (
      <>
        {user.loggedIn ? <ChildHeader /> : <NoUserHeader />}
        <Box p={8}>
          <Flex direction={'column'} bg={'#F3F3F3'} p={6} borderRadius={10}>
            <Image src={AvisoPendencias} w={30} alignSelf={'center'} />
            <Text fontSize={16} fontWeight={'bold'} color={'#585858'} my={4}>
              Não é <span style={{ color: '#CB0000' }}> possível reativar </span> seu contrato
            </Text>
            <Spacer border={'0.1px solid #E6E6E6'} />
            <Text fontSize={'16px'} color={'#585858'} my={4}>
              Você só poderá reativar seu contrato 90 dias após a data do cancelamento
            </Text>

            <Button
              isFullWidth
              colorScheme="teal"
              onClick={() => {
                navigate('/dashboard');
              }}
            >
              Entendi
            </Button>
          </Flex>
        </Box>
      </>
    ) : (
      <>
        {user.loggedIn ? <ChildHeader /> : <NoUserHeader />}
        <DrawerIndicacao disclosure={{ isOpen: drawerOpen, onClose: () => setDrawerOpen(false) }} clientId={clientId} />

        <Box p={2} borderRadius={10} m={2} display="flex" flexDirection="column" alignItems="center" justifyContent="center" textAlign="center">
          <Image src={FamiliaIcon} alt="Emoji de dinheiro" width={60} mb={2} />
          <Text color="#616161" textAlign="center">
            No DeoVita você tem acesso a Pronto Atendimento 24h, Pediatria Online 24h +12 especialidades.
          </Text>
          <Text color="#616161" textAlign="center">
            Além de um veterinário online para tirar dúvidas sobre a saúde do seu amigo de quatro patas.
          </Text>
        </Box>
        <Box w="100%" display="flex" justifyContent="center" alignItems="center" mb={2}>
          <Text color={!isAnual ? '#237973' : '#616161'} fontWeight="bold" mr={2}>
            Mensal
          </Text>
          <Switch colorScheme="teal" isChecked={isAnual} onChange={() => setIsAnual((prev) => !prev)} size="lg" id="switch-anual" mx={2} />
          <Text color={isAnual ? '#237973' : '#616161'} fontWeight="bold" ml={2}>
            Anual
          </Text>
        </Box>
        {isAnual && (
          <>
            <Text fontSize={{ base: 'sm', sm: 'md' }} mt={2} color="#616161" textAlign={'center'}>
              Obtenha{' '}
              <Text as="span" color="#5AB2AE" fontWeight="bold">
                duas parcelas grátis
              </Text>{' '}
              <br /> assinando em {maxParcelas}X no cartão
            </Text>
          </>
        )}
        <Flex w="100%" justify="center" align="center" py={2}>
          <Box
            w={{ base: '95%', md: '70%', lg: '50%' }}
            maxW="500px"
            mx="auto"
            border="1px solid #5AB2AE"
            p={2}
            borderRadius={10}
            boxShadow="md"
            bg="white"
          >
            {user && user.voucher && user.voucher.voucher && (
              <Box mb={4} display="flex" flexDirection="column" alignItems="center">
                <Text fontWeight="bold" color="#2A918A" fontSize="md" letterSpacing={1} mb={2}>
                  Voucher Aplicado
                </Text>

                <Flex align="center" bg="#F7FDFC" px={4} py={2} borderRadius={10} boxShadow="sm" gap={3}>
                  <Text fontSize="sm" color="#616161" fontWeight="medium">
                    {user.voucher.voucher.voucher_type === 'Assinatura'
                      ? user.voucher.voucher.voucher
                      : user.voucher.voucher.vendedor_id || user.voucher.voucher.voucher}
                  </Text>

                  <IconButton
                    aria-label="Remover voucher"
                    icon={<CloseIcon boxSize={3.5} />}
                    size="sm"
                    variant="ghost"
                    colorScheme="red"
                    borderRadius="full"
                    _hover={{
                      bg: 'red.50',
                      transform: 'scale(1.05)',
                    }}
                    _active={{
                      transform: 'scale(0.95)',
                    }}
                    onClick={() => {
                      setUser((prevUser) => ({
                        ...prevUser,
                        voucher: null,
                      }));
                    }}
                  />
                </Flex>
              </Box>
            )}
            {planosExibir.length > 0 && (
              <Tabs variant="unstyled" w="100%">
                <TabList
                  p={1}
                  borderRadius="10px"
                  display="flex"
                  mb={2}
                  overflowX="auto"
                  sx={{
                    '::-webkit-scrollbar': { height: '6px' },
                    '::-webkit-scrollbar-thumb': { background: '#E0E0E0', borderRadius: '10px' },
                  }}
                >
                  {planosExibir.map((plan, idx) => (
                    <Tab
                      key={plan.id}
                      _selected={{
                        bg: '#2A918A',
                        color: 'white',
                        borderRadius: '10px',
                      }}
                      px={6}
                      py={3}
                      fontWeight="medium"
                      color="#2A918A"
                      minW="180px"
                      flexShrink={0}
                      whiteSpace="nowrap"
                    >
                      <HStack spacing="6px">
                        {plan.id === 29 ? <Icon as={MdFamilyRestroom} /> : <Icon as={FaUser} />}
                        <Text>{plan.nome}</Text>
                      </HStack>
                    </Tab>
                  ))}
                </TabList>
                <TabPanels mt={4}>
                  {planosExibir.map((plan) => {
                    let valorFinal = null;
                    let descontoPercent = null;
                    if (
                      user &&
                      user.voucher &&
                      user.voucher.voucher &&
                      user.voucher.voucher.voucher_type === 'Assinatura' &&
                      String(plan.id) === String(user.voucher.voucher.plano_id)
                    ) {
                      descontoPercent = user.voucher.voucher.percent;
                    }
                    const parcela = isAnual
                      ? plan.parcelas && plan.parcelas.find((p) => p.quantidade === 1)
                      : plan.parcelas && plan.parcelas.find((p) => p.quantidade === 12);
                    if (parcela && descontoPercent) {
                      valorFinal = Number(parcela.min_valor) * (1 - descontoPercent / 100);
                    } else if (
                      user &&
                      user.voucher &&
                      user.voucher.voucher &&
                      user.voucher.voucher.voucher_type === 'Assinatura' &&
                      String(plan.id) === String(user.voucher.voucher.plano_id)
                    ) {
                      valorFinal = user.voucher.voucher.valor_final;
                    }
                    return (
                      <TabPanel key={plan.id}>
                        <PlanoCard
                          planId={plan.id}
                          titulo={`Assinatura Plano ` + plan.nome}
                          preco={
                            valorFinal !== null
                              ? Number(valorFinal).toLocaleString('pt-br', { style: 'currency', currency: 'BRL' })
                              : parcela
                                ? Number(parcela.min_valor).toLocaleString('pt-br', { style: 'currency', currency: 'BRL' })
                                : ''
                          }
                          beneficios={plan.beneficios ? plan.beneficios.map((b) => b.descricao || b) : []}
                          recomendado={plan.recomendado}
                          onAssinar={() => handleSubmit(plan)}
                        />
                      </TabPanel>
                    );
                  })}
                </TabPanels>
              </Tabs>
            )}
          </Box>
        </Flex>
        {/* Box de menor valor movida para PagamentoTelemedicina.jsx */}
      </>
    )
  ) : error ? (
    navigate('/alerts/erro/cadastro_plano')
  ) : null;
}

export default Plano;
